/**
 * Typical densities of everyday solids, for the buoyancy calculator.
 *
 * Rounded reference values at about 20 °C (ice at 0 °C), from the CRC Handbook of
 * Chemistry and Physics for the pure elements (aluminium 2.70, iron 7.874, copper 8.96,
 * lead 11.34, gold 19.32 g/cm³) and engineering tables for the mixtures. Wood, concrete
 * and steel vary from sample to sample — the numbers are "typical", not exact — and ice
 * is 0.917 g/cm³, which is why icebergs float with about 92% of their volume below the
 * surface in fresh water.
 */

export type MaterialId =
  | "cork"
  | "pine"
  | "oak"
  | "ice"
  | "glass"
  | "concrete"
  | "aluminium"
  | "steel"
  | "copper"
  | "lead"
  | "gold";

export interface Material {
  id: MaterialId;
  /** Density, kg/m³. */
  density: number;
}

export const MATERIALS: readonly Material[] = [
  { id: "cork", density: 240 },
  { id: "pine", density: 500 },
  { id: "oak", density: 750 },
  { id: "ice", density: 917 },
  { id: "glass", density: 2500 },
  { id: "concrete", density: 2400 },
  { id: "aluminium", density: 2700 },
  { id: "steel", density: 7850 },
  { id: "copper", density: 8960 },
  { id: "lead", density: 11_340 },
  { id: "gold", density: 19_320 },
];

export function findMaterial(id: string): Material | null {
  return MATERIALS.find((material) => material.id === id) ?? null;
}
